import { render, staticRenderFns } from "./JzzLoginComponent.vue?vue&type=template&id=e162bcc8&scoped=true"
import script from "./JzzLoginComponent.vue?vue&type=script&lang=js"
export * from "./JzzLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./JzzLoginComponent.vue?vue&type=style&index=0&id=e162bcc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e162bcc8",
  null
  
)

export default component.exports